import React from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import BackAnchor from 'shared/components/BackAnchor'
import DebtInformationListTable from './DebinformationListTable';
import AddDebtInformationView from './AddDebtInformationView';
import styles from './DebtInformationList.module.scss'
import { useHistory } from 'react-router';
import { setEditDebtInfo } from 'redux/actions'

const DebtInformationListView = ({ t, i18n, setIsError }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const editDebtInfoId = useSelector((state) => state.app.editDebtInfoId)
  const debtInformationList = useSelector((state) => state.app.debtInformationList)

  const onNextClick = () => {
    try {
      history.push(`/${i18n.language}${t('routes.contact_information')}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const onBackClick = () => {
    const id = editDebtInfoId.length > 0 ? editDebtInfoId : (debtInformationList[0]?.fileNumber ?? '')
    dispatch(setEditDebtInfo(id));
  }

  return (
    <div className="container">
      <div className="row">
        <BackAnchor onBackClick={onBackClick} />
      </div>
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <DebtInformationListTable setIsError={setIsError} />
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <button
            className={['btn-lg btn-default', styles['next_button']].join(' ')}
            onClick={onNextClick}
            value={t('shared.next')}
            name={t('shared.next')}
          >
            {t('shared.next')}
          </button>
        </div>

      </div>
      <AddDebtInformationView t={t} setIsError={setIsError} />
    </div>
  )
}

export default withTranslation('common')(DebtInformationListView)
